import React, { useState } from 'react';

import StockMobileSidePanel from '@/components/StockMobileSidePanel';
import { OptionType } from '@/typings/common';
import { useTypedDispatch, useTypedSelector } from '@/store/store';
import {
  getSelectedFilters,
  getStockFilterParams,
  setCarWheel,
  setPage,
} from '@/store/reducers/cars-stock';
import {
  convertFilterParamsToOptionsByKey,
  handleChangeMultiSelect,
} from '@/modules/CarsStock/components/common.helpers';
import StockFilterMultiSelect from '@/components/StockFilterMultiSelect';

import {
  FilterButton,
  FilterButtonWrapper,
  MobileFilterItemWrapper,
} from '../../../../../../../common.styles';

function WheelFilter() {
  const dispatch = useTypedDispatch();
  const stockFilterParams = useTypedSelector(getStockFilterParams);
  const selectedWheel =
    useTypedSelector(getSelectedFilters).selectedParams.selectedWheel;
  const [isOpened, setOpened] = useState(false);

  const handleSidePanelOpen = () => {
    setOpened(true);
  };

  const handleSidePanelClose = () => {
    setOpened(false);
  };

  const wheelOptions = convertFilterParamsToOptionsByKey(
    stockFilterParams,
    'wheels'
  );

  const handleChangeWheel = (wheel: OptionType) => {
    dispatch(setCarWheel(handleChangeMultiSelect(wheel, selectedWheel)));
    dispatch(setPage(1));
  };

  const handleClearWheel = () => {
    dispatch(setCarWheel([]));
    dispatch(setPage(1));
  };

  return (
    <StockMobileSidePanel
      title="Привод"
      zIndex={10001}
      isInnerSidePanel
      isOpened={isOpened}
      onOpen={handleSidePanelOpen}
      onClose={handleSidePanelClose}
    >
      <MobileFilterItemWrapper>
        <StockFilterMultiSelect
          options={wheelOptions}
          selectedOptions={selectedWheel}
          onChange={handleChangeWheel}
          onClear={handleClearWheel}
        />
      </MobileFilterItemWrapper>

      <FilterButtonWrapper>
        <FilterButton onClick={handleSidePanelClose}>Применить</FilterButton>
      </FilterButtonWrapper>
    </StockMobileSidePanel>
  );
}

export default WheelFilter;
